import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.time-zones';
import * as api from '../../../clients/api';

@Injectable()
export class ApiTimeZonesEffects {

    TimeZones$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_TIME_ZONES),
        mergeMap((x: ac.GetTimeZonesAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getTimeZones().pipe(
                map((result: any) => {
                    return new ac.GetTimeZonesErfolgreichAction(optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetTimeZonesFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ApiService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ApiService {
        if (this.service === null) {
            this.service = this.injector.get(api.ApiService);
        }
        return this.service;
    }
}
